import classNames from "classnames";
import React from "react";
import styles from "./DividerWithText.module.css";
import type { DividerWithTextProps } from "./types";

/**
 * DividerWithText Atom
 *
 * A horizontal divider with text content between decorative lines.
 * Useful for section separators with labels or summary information.
 *
 * @example
 * ```tsx
 * <DividerWithText>3 dager markert</DividerWithText>
 * ```
 */
export const DividerWithText: React.FC<DividerWithTextProps> = ({
  children,
  legend = "0 DAGER MARKERT",
  className,
  "data-testid": testId,
}) => {
  return (
    <div className={classNames(styles.dividerWithText, className)}>
      <fieldset data-testid={testId}>
        <legend>{legend}</legend>
        <span data-type="content">{children}</span>
      </fieldset>
    </div>
  );
};

DividerWithText.displayName = "DividerWithText";

export default DividerWithText;
